import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'

import Modal from '@mui/material/Modal'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'

import SectionTitle from 'src/components/kit/SectionTitle'
import ErrorsTable from './ErrorsTable'
import UiButton from 'src/ui/atoms/Button'
import './ReviewCsvModal.scss'

export default function ReviewCsvModal({
  showReviewCsvModal,
  toggleReviewCsvModal,
  data,
}: {
  showReviewCsvModal: boolean
  toggleReviewCsvModal: () => void
  data: { row: number; receiver?: string; amount?: string | number }[]
}) {
  const hasReceiver = data?.some((tx) => tx?.receiver)
  const hasAmount = data?.some((tx) => tx?.amount)

  return (
    <Modal
      open={showReviewCsvModal}
      onClose={toggleReviewCsvModal}
      aria-labelledby="confirm-modal"
      aria-describedby="confirm-remove-modal">
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: '300px',
          maxHeight: '90%',
          width: '580px',
          maxWidth: '90%',
          background: '#181D38',
          color: '#fff',
          borderRadius: '16px',
        }}>
        <Box
          py={3}
          pl={2}
          pr={3}
          sx={{
            width: '100%',
            height: '100%',
            minHeight: '300px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            borderRadius: '8px',
            boxSizing: 'border-box',
          }}>
          <SectionTitle
            title={`Some transactions have an incorrect ${
              hasReceiver && hasAmount
                ? 'receiver address / amount'
                : hasReceiver
                ? 'receiver address'
                : hasAmount
                ? 'amount'
                : ''
            }. Please review them and upload the csv again.`}
          />
          <div className="txListContainer">
            <PerfectScrollbar>
              <ErrorsTable data={data} />
            </PerfectScrollbar>
          </div>
          <Box
            mt={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              width: '100%',
            }}>
            <UiButton name="Cancel" size="M" onClick={toggleReviewCsvModal} type="secondary" />
          </Box>
        </Box>
      </Card>
    </Modal>
  )
}
